const AuthTypes = {
  LOGIN: 'LOGIN',
  SET_STATE: 'SET_STATE',
  LOGOUT: 'LOGOUT',
  ACCESS_DENIED: 'ACCESS_DENIED',
  TOKEN_LOGIN: 'TOKEN_LOGIN'
};

export default AuthTypes;
